import React from 'react';

const TRACKS = [
  { label: 'V1', start: 6, width: 58 },
  { label: 'V2', start: 38, width: 48 },
  { label: 'A1', start: 14, width: 70 },
  { label: 'A2', start: 52, width: 34 },
];

export default function ArticleVisual({ article, featured = false }) {
  const variant = Number.parseInt(article?.number || '1', 10) % 5;
  return (
    <div className={`inside-visual inside-visual--${variant}${featured ? ' inside-visual--featured' : ''}`} aria-hidden="true">
      <div className="inside-visual-topbar">
        <span>JKL_INSIDE_{article?.number || '00'}</span>
        <span>25 FPS</span>
      </div>
      <div className="inside-visual-monitor">
        <div className="inside-visual-safe" />
        <span className="inside-visual-number">{article?.number || '00'}</span>
        <span className="inside-visual-category">{article?.category || 'INSIDE'}</span>
        <span className="inside-visual-timecode">01:00:{article?.number || '00'}:00</span>
      </div>
      <div className="inside-visual-timeline">
        <div className="inside-visual-ruler"><span>00</span><span>05</span><span>10</span><span>15</span><span>20</span></div>
        {TRACKS.map((track, index) => (
          <div className="inside-visual-track" key={track.label}>
            <span>{track.label}</span>
            <i style={{ left: `${(track.start + variant * 3) % 58}%`, width: `${track.width - variant * 2}%` }} className={`clip clip--${index + 1}`} />
          </div>
        ))}
        <b className="inside-visual-playhead" />
      </div>
    </div>
  );
}
